export default "__VITE_ASSET__BSAOgBud__"